export let routes = {
  reviewPipelines: "reviewpipelines",
  users: "users",
  predictors: "predictors", 
  studies: "studies"
};
